module.exports = __webpack_public_path__ + "media/img/avatars/projects/project-4-0168b1be4132a0add4e2165a000f3c1d.jpg";